
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/linear/moon","xmlns":"http://www.w3.org/2000/svg","width":"34","height":"34","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.527 31.938c-.235 0-.474-.005-.71-.015a15.769 15.769 0 01-10.22-4.417 15.273 15.273 0 01-2.391-19.3 15.683 15.683 0 017.175-6.047 3.981 3.981 0 011.535-.353 1.961 1.961 0 011.712.852 2.678 2.678 0 01-.029 2.65 11.494 11.494 0 00-.972 4.726 12.1 12.1 0 0011.571 11.833c.177.007.356.011.531.011a12.381 12.381 0 002.177-.193 4.879 4.879 0 01.868-.084 2.128 2.128 0 012.082 1.081c.229.455.459 1.426-.575 2.829a15.721 15.721 0 01-5.478 4.676 15.973 15.973 0 01-7.276 1.751zM12.916 3.806a2.016 2.016 0 00-.756.195 13.521 13.521 0 00-8.308 13.393 13.752 13.752 0 0013.052 12.531c.206.009.416.013.622.013a13.818 13.818 0 0011.14-5.609 2.008 2.008 0 00.372-.7 1.256 1.256 0 00-.267-.025 2.9 2.9 0 00-.513.052 14.4 14.4 0 01-2.533.225c-.2 0-.409 0-.614-.013a14.121 14.121 0 01-13.483-13.823 13.476 13.476 0 011.138-5.539 1.769 1.769 0 00.185-.7z","fill":"#4c535f"}})])
          )
        }
      }
    